import { KPK_CODE_LENGTH, KPK_JOIN_ERROR_IDS } from './constants';
import type { ExtendedTeacherKPK } from './store/types';

const validCodeRegExp = new RegExp(/^[A-Za-z0-9]*$/);

export const getCodeErrorMessageId = (error: (typeof KPK_JOIN_ERROR_IDS)[keyof typeof KPK_JOIN_ERROR_IDS] | null) => {
    switch (error) {
        case KPK_JOIN_ERROR_IDS.CODE_IS_EMPTY:
            return 'teacherTrainingCourses.joinCode.errorMessage.emptyCode';
        case KPK_JOIN_ERROR_IDS.CODE_WAS_USED:
            return 'teacherTrainingCourses.joinCode.errorMessage.wasUsed';
        case KPK_JOIN_ERROR_IDS.COURSE_NOT_FOUND:
            return 'teacherTrainingCourses.joinCode.errorMessage.notFound';
        case KPK_JOIN_ERROR_IDS.CODE_INVALID:
            return 'teacherTrainingCourses.joinCode.errorMessage.invalid';
        case KPK_JOIN_ERROR_IDS.CODE_ALREADY_USED:
            return 'teacherTrainingCourses.joinCode.errorMessage.alreadyUsed';
        default:
            return null;
    }
};

/** Делит один введенный код на два – для курса и пользователя */
const splitCodeInParts = (code: string) => {
    const coursePart = code.slice(0, KPK_CODE_LENGTH / 2);
    const userPart = code.slice(KPK_CODE_LENGTH / 2);

    return { coursePart, userPart };
};

/** Проверяет что код состоит из латинских букв/цифр, и его длину */
export const checkIsCodeValid = (code: string): code is string => {
    if (code.length !== KPK_CODE_LENGTH) {
        return false;
    }

    const { coursePart, userPart } = splitCodeInParts(code);

    return validCodeRegExp.test(coursePart) && validCodeRegExp.test(userPart);
};

/** Находит введенный код среди существующих курсов */
export const findCodeInCourses = (code: string, courses: ExtendedTeacherKPK[]) => {
    const { coursePart } = splitCodeInParts(code);

    const courseWithCode = courses.find(
        ({ courseCode }) => courseCode !== undefined && courseCode.toUpperCase() === coursePart.toUpperCase()
    );

    return courseWithCode === undefined ? null : courseWithCode;
};
